/* ════════════════════════════════════════════════════════════
   4N6 / micro-interactions.js
   - Scroll progress bar (top of viewport)
   - IntersectionObserver staggered reveals
   - Hero letter-spacing collapse on load
   - Smooth scroll for in-page anchors
   - Cursor-ring hover state on interactive targets
   All effects respect [data-motion] and prefers-reduced-motion.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = function () { return html.getAttribute('data-motion') || 'restrained'; };

  /* ── Scroll progress bar ── */
  (function () {
    var bar = document.createElement('div');
    bar.className = 'scroll-progress';
    document.body.appendChild(bar);
    var raf = null;
    function update() {
      raf = null;
      var doc = document.documentElement;
      var scrolled = window.scrollY;
      var height = doc.scrollHeight - doc.clientHeight;
      var pct = height > 0 ? (scrolled / height) * 100 : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', function () {
      if (raf == null) raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  /* ── IntersectionObserver staggered reveals ── */
  (function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    function tagReveals() {
      // Sections
      var groups = [
        { sel: '.page-section, .newsletter-section, .ascii-hero, .ascii-marquee', stagger: false },
        { sel: '.ascii-card', stagger: true },
        { sel: '.look-cell',  stagger: true },
        { sel: '.ascii-table li', stagger: true },
      ];
      groups.forEach(function (g) {
        var els = document.querySelectorAll(g.sel);
        els.forEach(function (el, i) {
          if (el.classList.contains('reveal')) return;
          el.classList.add('reveal');
          if (g.stagger) el.style.setProperty('--i', i % 8);
          io.observe(el);
        });
      });

      // Section headers (animated rule sweep on full motion)
      document.querySelectorAll('.ascii-section-header').forEach(function (h) {
        if (h.classList.contains('reveal')) return;
        var hio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { h.classList.add('is-visible'); hio.disconnect(); }
          });
        }, { threshold: 0.4 });
        hio.observe(h);
      });
    }
    tagReveals();
    // Re-tag on Shopify Theme Editor section reload
    document.addEventListener('shopify:section:load', tagReveals);
  })();

  /* ── Hero title letter-spacing collapse on load ── */
  (function () {
    var t = document.querySelector('.ascii-hero__title');
    if (!t || reduce) return;
    t.classList.add('is-collapsing');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        t.classList.remove('is-collapsing');
      });
    });
  })();

  /* ── Smooth scroll for in-page anchors ── */
  (function () {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (id === '#' || id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  /* ── Cursor-ring hover scaling on interactive elements ── */
  (function () {
    var ring = document.getElementById('cursor');
    if (!ring) return;
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var sel = 'a, button, .ascii-card, .look-cell, .filter-btn, .term-btn, [data-theme-toggle], [data-motion-toggle]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(sel)) ring.classList.add('is-hovering');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(sel)) ring.classList.remove('is-hovering');
    });
  })();
})();
